import { render, staticRenderFns } from "./create-grouping-package.vue?vue&type=template&id=342f3862&"
import script from "./create-grouping-package.vue?vue&type=script&lang=ts&"
export * from "./create-grouping-package.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports